import Section, {
  CloudWrapper,
  DevOpsWrapper,
  ServiceWrapper,
} from "./services.style"

import Arrow from "../../common/assets/image/alpacked/services/arrow.svg"
import ArrowLight from "../../common/assets/image/alpacked/services/arrowLight.svg"
import Container from "../../components/UI/Container"
import Heading from "../../components/Heading"
import { Link } from "gatsby"
import React from "react"
import Text from "../../components/Text"
import striptags from "striptags"

const Service = ({ cloud, devOps, url }) => {
  return (
    <Section>
      <Container width="1220px">
        <ServiceWrapper>
          <CloudWrapper>
            <Heading
              as={cloud.primary.title.html.substring(1, 3)}
              content={striptags(cloud.primary.title.html)}
            />
            <ul>
              {cloud.items.map((item, index) => {
                return (
                  <li key={index}>
                    <div>
                      <img
                        src={item.icon.url}
                        alt="certifications"
                        className="service-icon"
                      />
                      <Link to={`/${url}/${item.link.uid}/`}>
                        <Text
                          content={item.link.document?.data.title.text}
                          className="service-titles"
                        />
                      </Link>
                    </div>
                    <img
                      loading="lazy"
                      src={Arrow}
                      alt="arrow"
                      className="arrow"
                    />
                  </li>
                )
              })}
            </ul>
          </CloudWrapper>
          <DevOpsWrapper>
            <Heading
              as={devOps.primary.title.html.substring(1, 3)}
              content={striptags(devOps.primary.title.html)}
            />
            <ul>
              {devOps.items.map((item, index) => {
                return (
                  <li key={index}>
                    <div>
                      <img
                        src={item.icon.url}
                        alt="certifications"
                        className="service-icon"
                      />
                      <Link to={`/${url}/${item.link.uid}/`}>
                        <Text
                          content={item.link.document.data.title.text}
                          className="service-titles"
                        />
                      </Link>
                    </div>
                    <img
                      loading="lazy"
                      src={ArrowLight}
                      alt="arrowLight"
                      className="arrow"
                    />
                  </li>
                )
              })}
            </ul>
          </DevOpsWrapper>
        </ServiceWrapper>
      </Container>
    </Section>
  )
}

export default Service
